/**
 * Histopathology Home – Demographics (dummy screen).
 */
import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function Demographics() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" color="text.secondary" sx={{ fontSize: "1.1dvw" }}>Histopathology – Demographics</Typography>
    </Box>
  );
}
